import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ProductDetails, ProductResponse, PromoCode, TierName } from "app/models/products.model";
import { ApiResponse } from "app/utilities/api-data.utilities";
import { map, Observable } from "rxjs";

@Injectable()
export class ProductService {

    productDetailsUrl = "";

    constructor(
        private httpClient: HttpClient,
      ) {}

      
	fetchProducts(): Observable<ProductResponse> {
      const request = 
      [  
        {
          "search": "RBRVS",
          "pricecodes": [
            { "pricecode": "MEMBER" },
            { "pricecode": "NONMBR" }
          ]
        }
    ]
    return this.httpClient
      .post<ProductResponse>('ocmapi/getproductiers', request);
	}

  getProductDetails(prodName: string): Observable<ProductDetails> {
    const url = this.productDetailsUrl;
    return this.httpClient.get(url).pipe(
      map((_response) => {
        const response = _response as ApiResponse<ProductDetails>;
        return response.data;
    }));
  }

  validatePromoCode(customerNumber: string,
                    promoCode: string, lines:any): Observable<PromoCode> {
    const request = {
      "CustomerNumber": customerNumber,
      "PromotionCode": promoCode,
      "lines": lines
    }
    return this.httpClient.post<PromoCode>('ocmapi/validatePromoCode', request);
  }
}